import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VendorNotificationModule } from './vendor-notification/vendor-notification.module';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    VendorNotificationModule
  ]
})
export class NotificationModule { }
